import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../components/Header';
import WordCard from '../components/WordCard';
import WordCollections from '../components/WordCollections';
import Subscription from '../components/Subscription';
import DonationBanner from '../components/DonationBanner';
import Footer from '../components/Footer';
import api from '../services/api';
import './Homepage.css';

const Homepage = () => {
  const [wordOfTheDay, setWordOfTheDay] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const location = useLocation();

 useEffect(() => {
    const loadWordOfTheDay = async () => {
      try {
        setIsLoading(true);
        const data = await api.getWordOfTheDay();
        
        // Fetch all additional data in parallel
        const [
          usage,
          similar,
          mnemonicsData
        ] = await Promise.all([
          api.getUsageExamples(data.word),
          api.getSimilarWords(data.word),
          api.getWordMnemonics(data.word)
        ]);
        
        // Transform the data to match WordCard props
        const transformedData = {
          word: data.word,
          pronunciation: data.ipa,
          pronunciationAudio: data.pronunciationAudio,
          partOfSpeech: data.partsOfSpeech,
          definition: data.quickDefinition,
          example: data.quickExample,
          personaExplanation: data.explanations,
          examples: usage,
          similarWords: similar,
          meanings: data.meanings || [],
          mnemonics: Array.isArray(mnemonicsData.mnemonics) ? mnemonicsData.mnemonics : [],
          wordListTags: data.wordListTags
        };
        
        setWordOfTheDay(transformedData);
      } catch (err) {
        console.error('Error loading word of the day:', err);
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    loadWordOfTheDay();
  }, []);


  useEffect(() => {
    if (location.hash === '#collections') {
      setTimeout(() => {
        const element = document.getElementById('collections');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }
  }, [location]);

  return (
    <div className="homepage">
      {/* Header with search */}
      <Header />

      {/* Main content */}
      <main className="main-content">
        {/* Word Card Section */}
        <section className="word-of-the-day-section">
          <div className="section-header">
            <span className="section-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
              </svg>
            </span>
            <h2 className="section-title">Word of the Day</h2>
          </div>
          <div className="word-card-container">
            {isLoading ? (
              <div className="loading-container">
                <div className="loading-spinner"></div>
                <p className="loading-message">Loading word of the day...</p>
              </div>
            ) : error ? (
              <div className="error-container">
                <p className="error-message">Failed to load word of the day: {error}</p>
              </div>
            ) : wordOfTheDay ? (
              <WordCard {...wordOfTheDay} />
            ) : null}
          </div>
        </section>

        {/* Word Collections Section */}
        <section id="collections" className="word-collections-section">
          <WordCollections />
        </section>

        {/* Subscription Section */}
        <section className="subscription-section">
          <Subscription />
        </section>

        {/* Donation Banner */}
        <section className="donation-section">
          <DonationBanner />
        </section>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Homepage; 
